export const SYSTEM_ALT_LOG_LAST_READING_INFO_OPEN_MODAL = "SYSTEM_ALT_LOG_LAST_READING_INFO_OPEN_MODAL";
export const SYSTEM_ALT_LOG_LAST_READING_INFO_REQUEST = "SYSTEM_ALT_LOG_LAST_READING_INFO_REQUEST";
export const SYSTEM_ALT_LOG_LAST_READING_INFO_RESULT = "SYSTEM_ALT_LOG_LAST_READING_INFO_RESULT";
